import { Typography } from "antd"
import { getDateString } from "utils/date"

export const DateCell = ({ value }: { value: any }) => {
    const parsedValue = getDateString(value, "YYYY-MM-DD HH:mm:ss")
    return <Typography.Text>{parsedValue}</Typography.Text>
}
